import { render, staticRenderFns } from "./CbsWidgetDonut.vue?vue&type=template&id=1de181d2&scoped=true"
import script from "./CbsWidgetDonut.vue?vue&type=script&lang=js"
export * from "./CbsWidgetDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de181d2",
  null
  
)

export default component.exports